"use client";
import { FirstContactBox } from "@/app/(content)/components/contact-box";
import { forHomeOwners, servicesList } from "../shared/page-navigation";
import Link from "next/link";
import Image from "next/image";

export const Footer = () => {
  return (
    <footer className="relative z-10 font-light text-gray-300">
      {/* Premium contact section with subtle shadow */}
      {/* <FirstContactBox sendLeft /> */}

      {/* Main footer content with premium styling */}
      <div className="relative w-full overflow-hidden bg-gradient-to-b from-gray-900 via-gray-900 to-gray-950">
        {/* Subtle orange sun effect */}
        <div
          className="pointer-events-none absolute top-0 left-1/2 h-[300px] w-[300px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-orange-700 opacity-20 blur-3xl lg:h-[800px] lg:w-[800px] lg:opacity-[0.08]"
          style={{ filter: "blur(150px)" }}
        ></div>

        {/* Subtle top border accent */}
        <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-transparent via-orange-500/30 to-transparent"></div>

        <div className="container py-16">
          {/* Top section with logo and navigation columns */}
          <div className="grid grid-cols-1 gap-x-12 gap-y-12 px-6 md:grid-cols-2 lg:grid-cols-12">
            {/* Logo and company description - spans 3 columns on large screens */}
            <div className="flex flex-col gap-5 lg:col-span-3">
              <Link
                href="/"
                className="inline-block max-w-[180px] transition duration-300 hover:opacity-90"
              >
                <Image
                  src="/LogoOrange.svg"
                  width={180}
                  height={45}
                  alt="Vind Logo"
                  className="h-auto w-auto"
                  priority
                />
              </Link>
              <p className="text-sm leading-relaxed tracking-wide text-gray-400">
                vind - gemeinsam für eine energiesichere Zukunft. Wir bieten dir
                individuelle Lösungen für deinen Energiebedarf.
              </p>

              {/* Social media icons with premium styling */}
              <div className="mt-3 flex items-center space-x-4">
                {/* <a href="#" aria-label="LinkedIn" className="group flex h-9 w-9 items-center justify-center rounded-full border border-gray-700 bg-gray-800/30 text-gray-400 transition duration-300 hover:border-orange-500/50 hover:bg-gray-800/80 hover:text-orange-400">
                  <span className="sr-only">LinkedIn</span>
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a> */}
                {/* <a href="#" aria-label="Twitter" className="group flex h-9 w-9 items-center justify-center rounded-full border border-gray-700 bg-gray-800/30 text-gray-400 transition duration-300 hover:border-orange-500/50 hover:bg-gray-800/80 hover:text-orange-400">
                  <span className="sr-only">Twitter</span>
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.054 10.054 0 01-3.127 1.184 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </a> */}
                <a
                  href="https://www.instagram.com/vindsolar/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="group flex h-9 w-9 items-center justify-center rounded-full border border-gray-700 bg-gray-800/30 text-gray-400 transition duration-300 hover:border-orange-500/50 hover:bg-gray-800/80 hover:text-orange-400"
                >
                  <span className="sr-only">Instagram</span>
                  <svg
                    className="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>

            {/* Solutions column - spans 2 columns on large screens */}
            <div className="flex flex-col space-y-3 lg:col-span-2">
              <h3 className="text-base font-medium tracking-wider text-white uppercase">
                Lösungen
              </h3>
              <div className="mt-1 h-0.5 w-10 bg-gradient-to-r from-orange-500 to-orange-400"></div>
              <Link
                key={"selber-planen"}
                href={"/"}
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Solaranlage selbst gestalten
                </span>
              </Link>
              <Link
                key={"rechner"}
                href={"/rechner"}
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Alle vind Rechner
                </span>
              </Link>
              {forHomeOwners.map((service) => (
                <Link
                  key={service.href}
                  href={service.href}
                  className="group flex items-center text-gray-400 transition duration-200"
                  target={service.external ? "_blank" : undefined}
                  rel={service.external ? "noopener noreferrer" : undefined}
                >
                  <span className="flex items-center border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                    {service.left && (
                      <span className="mr-1 flex items-center">
                        {service.left}
                      </span>
                    )}
                    {service.title}
                  </span>
                </Link>
              ))}
            </div>

            {/* About column - spans 2 columns on large screens */}
            <div className="flex flex-col space-y-3 lg:col-span-2">
              <h3 className="text-base font-medium tracking-wider text-white uppercase">
                Über vind
              </h3>
              <div className="mt-1 h-0.5 w-10 bg-gradient-to-r from-orange-500 to-orange-400"></div>
              <Link
                href="/ueber-uns"
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Über uns
                </span>
              </Link>
              <Link
                href="/nutzungsbedingungen"
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Nutzungsbedingungen
                </span>
              </Link>
              <Link
                href="/agb"
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Allgemeine Geschäftsbedingungen
                </span>
              </Link>
              <Link
                href="/impressum"
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Impressum
                </span>
              </Link>
              <Link
                href="/datenschutz"
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Datenschutz
                </span>
              </Link>
            </div>

            {/* Information column - spans 2 columns on large screens */}
            <div className="flex flex-col space-y-3 lg:col-span-2">
              <h3 className="text-base font-medium tracking-wider text-white uppercase">
                Informationen
              </h3>
              <div className="mt-1 h-0.5 w-10 bg-gradient-to-r from-orange-500 to-orange-400"></div>
              {servicesList.map((service) => (
                <Link
                  key={service.href}
                  href={service.href}
                  className="group text-gray-400 transition duration-200"
                >
                  <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                    {service.title}
                  </span>
                </Link>
              ))}
              <Link
                key={"regionale-installation"}
                href={"/regionale-installation"}
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Regionale Informationen
                </span>
              </Link>
              <Link
                key={"wissenswertes"}
                href={"/wissenswertes"}
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Wissenswertes
                </span>
              </Link>
              <Link
                key={"glossar"}
                href={"/energie-glossar"}
                className="group text-gray-400 transition duration-200"
              >
                <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                  Energie Glossar <span className="text-xs text-orange-200 relative bottom-2">neu</span>
                </span>
              </Link>
            </div>

            {/* Guide column - spans 3 columns on large screens */}
            <div className="flex flex-col space-y-3 lg:col-span-3">
              <h3 className="text-base font-medium tracking-wider text-white uppercase">
                Ratgeber
              </h3>
              <div className="mt-1 h-0.5 w-10 bg-gradient-to-r from-orange-500 to-orange-400"></div>
              {ratgeberNavigation.map((service) => (
                <Link
                  key={service.href}
                  href={service.href}
                  className="group text-gray-400 transition duration-200"
                >
                  <span className="inline-block border-b border-transparent pb-1 transition-all duration-300 group-hover:border-orange-500/30 group-hover:text-orange-400">
                    {service.title}
                  </span>
                </Link>
              ))}
            </div>
          </div>

          {/* Bottom section with copyright and additional links */}
          <div className="mt-16 border-t border-gray-800/80 px-6">
            <div className="flex flex-col items-center justify-between space-y-6 py-8 md:flex-row md:space-y-0">
              <p className="text-center text-sm text-gray-500">
                © {new Date().getFullYear()} vind Solar Systeme GmbH. Alle
                Rechte vorbehalten.
              </p>

              {/* Additional links */}
              <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm text-gray-500">
                <div
                  onClick={() => {
                    localStorage.removeItem("react-hook-consent");
                    window.location.reload();
                  }}
                  className="cursor-pointer transition duration-200 hover:text-orange-400"
                >
                  Cookie-Einstellungen
                </div>
                {/* <Link href="/nachhaltigkeit" className="hover:text-orange-400 transition duration-200">
                  Nachhaltigkeit
                </Link> */}
                {/* <Link href="/karriere" className="hover:text-orange-400 transition duration-200">
                  Karriere
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const ratgeberNavigation = [
  {
    title: "Energieratgeber 2025",
    href: "/ratgeber",
  },
  {
    title: "Energiekosten senken",
    href: "/ratgeber/energiekosten-senken",
  },
  {
    title: "Stromkostenrechner 2025",
    href: "/ratgeber/energiekosten-senken/stromkosten-rechner-2025",
  },
  {
    title: "Heizung und Kühlung optimieren",
    href: "/ratgeber/heizung-und-kuehlung",
  },
  {
    title: "Energieverbrauch verstehen",
    href: "/ratgeber/energieverbrauch-verstehen",
  },
  {
    title: "Systemfehler verstehen und beheben",
    href: "/ratgeber/systemfehler-beheben",
  },
  {
    title: "Energieunabhängigkeit erkunden",
    href: "/ratgeber/energieunabhaengigkeit-erkunden",
  },
  {
    title: "Zu Solarenergie wechseln",
    href: "/ratgeber/zu-solaranlage-wechseln",
  },
  {
    title: "Haus effizienter gestalten",
    href: "/ratgeber/mein-zuhause-effizienter-machen",
  },
  {
    title: "CO2-Fußabdruck reduzieren",
    href: "/ratgeber/co2-fussabdruck-reduzieren",
  },
  {
    title: "Energiespeicher entdecken",
    href: "/ratgeber/energiespeicher-lernen",
  },
  {
    title: "Leistung verfolgen und verbessern",
    href: "/ratgeber/leistung-verbessern",
  },
];
